import React from "react";

const RELOAD_KEY = "nd_err_reloaded";

async function hardReload() {
  try {
    if ("serviceWorker" in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
    if (window.caches) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch { /* ignore */ }
  window.location.reload();
}

export class AppErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    console.error("NeuralDeck crashed:", error);
    let already = true;
    try { already = sessionStorage.getItem(RELOAD_KEY) === "1"; sessionStorage.setItem(RELOAD_KEY, "1"); } catch { /* ignore */ }
    if (!already) hardReload();
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div data-testid="app-error-fallback" style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 16, background: "#0B0E14", color: "#E6EDF3", fontFamily: "monospace", padding: 24, textAlign: "center" }}>
        <div style={{ color: "#00F0FF", letterSpacing: 2 }}>NEURALDECK HIT A SNAG</div>
        <div style={{ opacity: 0.7, maxWidth: 420 }}>Something failed to load in your browser. Reloading usually fixes it.</div>
        <button data-testid="app-error-reload-btn" onClick={hardReload} style={{ background: "#00F0FF", color: "#0B0E14", border: 0, padding: "10px 20px", fontWeight: 700, cursor: "pointer" }}>RELOAD</button>
      </div>
    );
  }
}
